import { getPerformance } from 'firebase/performance';
import { getFirebaseApp, isFirebaseConfigured } from './config';

// Firebase Performance Monitoring auto-collects page load, network request
// latency, and Web Vitals (LCP etc.) once initialised. No-op when unconfigured.
export function initPerformance(): void {
  if (!isFirebaseConfigured) return;
  const app = getFirebaseApp();
  if (!app) return;
  try {
    getPerformance(app);
  } catch {
    /* performance monitoring is best-effort */
  }
}
